import React from 'react';

import { ButtonGroup } from './styles';

const ButtonGroupBox = ({ children }) => {
  return <ButtonGroup>{children}</ButtonGroup>;
};

export default ButtonGroupBox;
